<template>
  <b-tab
    title="Tomador"
    :active="isTheCurrentTab"
    :disabled="!isTheCurrentTab"
    class="mt-5"
  >
    <b-row>
      <b-col>
        <b-form-group label="Nome" label-for="nome">
          <VueSelect
            ref="buscarCliente"
            :filterable="false"
            @input="setCliente"
            :class="{ hasErrors: clienteError, inputFilled: clienteFilled }"
            :options="clients"
            @search="onSearchCliente"
            v-model="store.formTomador"
          >
            <template slot="no-options">Informe o nome do cliente</template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>
                  {{ option.nome }}
                </div>
                <span class="text-muted"
                  >CPF/CNPJ: {{ formatCpfCnpj(option.cnpj_cpf) }}</span
                >
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.nome }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="CPF/CNPJ" label-for="cnpj_cpf">
          <b-form-input
            :key="keyToReRender"
            disabled
            id="cnpj_cpf"
            name="cnpj_cpf"
            v-model="store.formTomador.cnpj_cpf"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8">
        <b-form-group
          :key="keyToReRender"
          label="Endereço"
          label-for="endereco"
        >
          <VueSelect
            ref="endereco"
            :filterable="false"
            @input="setEndereco"
            :options="enderecos"
            :class="{ hasErrors: enderecoError, inputFilled: enderecoFilled }"
            @search="onSearchEndereco"
            :value="valueAdress"
          >
            <template slot="no-options"> Informe o Endereço </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{
                  `${option.cep ?? ""}, ${option.logradouro ?? ""}, ${
                    option.numero ?? ""
                  }, ${option.bairro ?? ""} - ${
                    option?.cidade?.cidade ?? ""
                  } / ${option?.cidade?.uf ?? ""}`
                }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="emissao" label-for="emissao" label="Data de emissão">
          <b-form-datepicker
            v-model="emissao"
            locale="pt-br"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          >
          </b-form-datepicker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="store.formTomador.prestacao_fora_municipio">
      <b-col md="12">
        <label>Dados do município onde serviço foi prestado:</label>
      </b-col>
      <b-col md="3">
        <b-form-group label="CEP" label-for="store.formTomador.cep_prestado">
          <b-form-input
            ref="cep"
            id="store.formTomador.cep_prestado"
            name="store.formTomador.cep_prestado"
            v-model="store.formTomador.cep_prestado"
            v-mask="['#####-###']"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group style="margin-top: 30px">
          <a
            class="btn btn-primary font-weight-bold"
            @click="consultaCepCidadePretado"
          >
            Consultar CEP
          </a>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Número"
          label-for="store.formTomador.numero_prestado"
        >
          <b-form-input
            id="store.formTomador.numero_prestado"
            name="store.formTomador.numero_prestado"
            v-model="store.formTomador.numero_prestado"
            aria-describedby="store.formTomador.numero_prestado"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Bairro"
          label-for="store.formTomador.bairro_prestado"
        >
          <b-form-input
            id="store.formTomador.bairro_prestado"
            name="store.formTomador.bairro_prestado"
            v-model="store.formTomador.bairro_prestado"
            aria-describedby="store.formTomador.bairro_prestado"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="5">
        <b-form-group
          label="Logradouro"
          label-for="store.formTomador.logradouro_prestado"
        >
          <b-form-input
            id="store.formTomador.logradouro_prestado"
            name="store.formTomador.logradouro_prestado"
            v-model="store.formTomador.logradouro_prestado"
            aria-describedby="store.formTomador.logradouro_prestado"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Complemento"
          label-for="store.formTomador.complemento_prestado"
        >
          <b-form-input
            id="store.formTomador.complemento_prestado"
            name="store.formTomador.complemento_prestado"
            v-model="store.formTomador.complemento_prestado"
            aria-describedby="store.formTomador.complemento_prestado"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Cidade" label-for="formEndereco.cidade">
          <VueSelect
            label="cidade"
            @input="setCidadePrestada"
            :options="cidades_prestadas"
            @search="onSearch"
          >
            <template slot="no-options"> Informe o nome da cidade </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.cidade + " - " + option.uf }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.cidade + " - " + option.uf }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <div class="border-bottom border-light py-3">
        <b-col md="12">
          <p class="font-weight-bolder text-dark mb-2">Calcular retenção</p>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input
                type="checkbox"
                v-model="store.formTomador.realizar_reducao"
              />
              <span></span>
            </label>
          </span>
        </b-col>
      </div>
      <div
        class="border-bottom border-light py-3"
        v-show="
          store.formTomador.cnpj_cpf && store.formTomador.cnpj_cpf.length >= 14
        "
      >
        <b-col md="12">
          <p class="font-weight-bolder text-dark mb-2">Situação Tributária</p>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input
                type="checkbox"
                v-model="store.formTomador.calcular_substituicao"
              />
              <span></span>
            </label>
          </span>
        </b-col>
      </div>
      <div class="border-bottom border-light py-3">
        <b-col md="12">
          <p class="font-weight-bolder text-dark mb-2">
            Prestação fora do município
          </p>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input
                type="checkbox"
                v-model="store.formTomador.prestacao_fora_municipio"
              />
              <span></span>
            </label>
          </span>
        </b-col>
      </div>
      <div class="border-bottom border-light py-3">
        <b-col md="12">
          <p class="font-weight-bolder text-dark mb-2">Retido pelo tomador</p>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input
                type="checkbox"
                v-model="store.formTomador.retido_pelo_tomador"
              />
              <span></span>
            </label>
          </span>
        </b-col>
      </div>
      <b-col md="8">
        <button
          ref="add_buyer"
          class="btn btn-primary font-weight-bold"
          v-b-modal.newClient
          style="font-size: 11px; margin-top: 30px; float: right"
        >
          Novo Cliente
        </button>
      </b-col>
    </b-row>
    <NovoClienteModal
      modal-id="newClient"
      @selected="handleNovoClienteSelected"
    />
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import {
  SistemaMixin,
  ValidacaoMixin,
  PessoaMixin,
} from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeServicos";
import { ClienteDataRequired } from "../ClienteData";
import NovoClienteModal from "@/modules/Pessoa/components/NovoClienteModal.vue";

export default {
  name: "app-nfse-form-tomador",
  components: {
    VueSelect,
    NovoClienteModal,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      emissao: null,
      firstLoad: false,
      clientSelected: {
        cnpj_cpf: null,
      },
      clients: [],
      clienteFilled: false,
      clienteError: false,
      enderecoError: false,
      enderecoFilled: false,
      keyToReRender: 0,
      enderecos: [],
      realizar_reducao: false,
      calcular_substituicao: false,
      cidades_prestadas: [],
      cidade_prestada: null,
      tipoBairro: [
        {
          descricao: "Bairro",
        },
        {
          descricao: "Chácara",
        },
        {
          descricao: "Distrito",
        },
        {
          descricao: "Fazenda",
        },
        {
          descricao: "Vila",
        },
      ],
      tipoLogradouro: [
        {
          descricao: "Rua",
        },
        {
          descricao: "Avenida",
        },
        {
          descricao: "Estrada",
        },
        {
          descricao: "Condomínio",
        },
        {
          descricao: "Sítio",
        },
        {
          descricao: "Travessa",
        },
        {
          descricao: "Rodovia",
        },
      ],
    };
  },
  validations: {
    form: ClienteDataRequired,
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, PessoaMixin],
  methods: {
    ...mapActions(["setLoading"]),
    onSearchEmail() {},
    onSearchCliente(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clients = await vm.getClientes(search);
      loading(false);
    }, 350),
    setCliente(cliente) {
      if (!cliente) return;
      if (this.bloquearClienteInadimplenteSelecionado(cliente)) {
        this.store.formTomador = {};
        this.clienteFilled = false;
        this.enderecos = [];
        this.keyToReRender++;
        return;
      }

      const enderecos = cliente.enderecos ?? cliente.endereco ?? [];

      this.store.formTomador = {
        ...cliente,
        enderecos,
      };
      this.clienteFilled = true;
      this.enderecos = enderecos;
      this.store.formTomador.endereco = enderecos[0] ?? null;
      this.keyToReRender++;
    },
    handleNovoClienteSelected(cliente) {
      this.setCliente(cliente);
    },
    async getTomador(id_pessoa) {
      const pessoa = await this.getPessoa(id_pessoa);
      this.store.formTomador = {
        ...this.store.formTomador,
        ...pessoa,
      };
    },
    searchEndereco: _.debounce(async (loading, search, vm) => {
      vm.enderecos = vm.enderecos.filter((endereco) =>
        endereco.includes(search)
      );
      loading(false);
    }, 350),
    onSearchEndereco(search, loading) {
      if (search.length) {
        loading(true);
        this.searcEndereco(loading, search, this);
      }
    },
    setEndereco(endereco) {
      this.store.formTomador.endereco = endereco;
      this.keyToReRender++;
      this.enderecoFilled = true;
    },
    formatEndereco(endereco) {
      if (!endereco) return "";
      const formatData = `${endereco.cep ?? ""}, ${
        endereco.logradouro ?? ""
      }, ${endereco.numero ?? ""}, ${endereco.bairro ?? ""} - ${
        endereco?.cidade?.cidade ?? ""
      } / ${endereco?.cidade?.uf ?? ""}`;
      return formatData;
    },
    async consultaCepCidadePretado() {
      this.setLoading(true);
      const cep = await this.getCep(this.store.formTomador.cep_prestado);

      if (cep.length == 0) {
        this.setLoading(false);
        return;
      }

      this.store.formTomador.logradouro_prestado = cep.logradouro;
      this.store.formTomador.bairro_prestado = cep.bairro;
      this.store.formTomador.complemento_prestado = cep.complemento;

      if (cep.erro) {
        this.setLoading(false);
        this.$toast.warning("Confira o CEP informado!");
        return;
      }

      const city = await this.getCidadeByUF(cep.localidade, cep.uf);
      this.cidades_prestadas = city;
      this.setLoading(false);
    },
    setCidadePrestada(cidade) {
      this.store.formTomador.cidade_prestada = cidade;
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce(async (loading, search, vm) => {
      const city = await vm.getCidade(search);
      vm.cidades_prestadas = city;
      loading(false);
    }, 350),
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      const { tomador, data_emissao, endereco } = this.$route.params.nfseData;
      this.getTomador(tomador.id_pessoa);
      this.emissao = data_emissao;
      this.store.formTomador.endereco = endereco;
    } else {
      this.store.formTomador = {};
      this.emissao = this.thisDate();
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 0;
    },
    valueAdress() {
      return this.store.formTomador?.endereco
        ? this.formatEndereco(this.store.formTomador.endereco)
        : null;
    },
  },
  watch: {
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 1 && oldValue < newValue) {
        if (_.isEmpty(this.store.formTomador)) {
          this.$toast.error("Selecione o tomador!");
          this.store.currentTab = oldValue;
          return;
        }
        if (_.isEmpty(this.store.formTomador.endereco)) {
          this.$toast.error("Selecione um endereço!");
          this.store.currentTab = oldValue;
        }
        if (!this.emissao) {
          this.store.currentTab = oldValue;
          this.$toast.error("Informe a data de emissão!");
        }
        this.store.formTomador.emissao = this.emissao;
      }
    },
  },
};
</script>
